import React from 'react';
import { useQuery } from 'react-apollo';
import omit from 'lodash.omit';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import { getAsset } from '../../../../../../../util/assets';
import { isIOSNativeAppWebView } from '../../../../../../../services/native-bridge/native-apps-interface';
import { AccountPromoCodeVerify } from '../../../../../../../graphql/queries/account-referrals';

const FreemiumEventTutorialWaldofiedUpsellStep = ({ waldofiedEventAddon }) => {
  const isIOSNativeAppWebViewBool = isIOSNativeAppWebView();
  const promoCode = 'MYWALDO';
  const { data: { accountPromoCodeVerify: accountPromoCode } = {} } = useQuery(
    AccountPromoCodeVerify,
    {
      variables: {
        promoCode,
        price: waldofiedEventAddon?.price
          ? omit(waldofiedEventAddon?.price, ['__typename'])
          : null,
      },
      fetchPolicy: 'network-only',
    },
  );

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <p className="text-center">
          Unlock easier joining, automated photo delivery to guests, and more
          with <span className="text-gold">Gold</span>
        </p>
        <img
          src={getAsset('/qr-code-upsell-illustration.png')}
          alt=""
          width="365"
          className="mb-2 mx-auto d-flex"
        />
        {/* TODO: The promo code should use a more targetted
         approach to avoid exposing single use codes */}
        {accountPromoCode?.is_eligible &&
          !isIOSNativeAppWebViewBool &&
          false && (
            <p>
              Use promo code <span className="text-bold">{promoCode}</span> for{' '}
              {promoCode?.discount?.value}% off
            </p>
          )}
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

export default FreemiumEventTutorialWaldofiedUpsellStep;
